import { css } from "@emotion/react";

export const rightMarginContext = css`
  margin-right: 2rem;
`;
export const fullHeightBox = css`
  padding: 1rem 1rem 2rem 1rem;
  height: 100%;
`;

export const fullWidthImage = css`
  width: 100%;
  height: 11.5rem;
  object-fit: cover;
`;

export const centered = css`
  justify-content: center;
`;
